import { TableData, TableRow } from "MVVM/Views/MatchHistory/styledComponents";
import { LoadingSkeleton } from "MVVM/Components/Skeloton";
import { Flex, Box } from "rebass/styled-components";
import styled from "styled-components";
const MatchesLoading = ({
  colSpan,
  rows,
}: {
  colSpan?: number;
  rows?: number;
}) => {
  return (
    <>
      {Array(rows || 3)
        .fill("")
        .map((_, index) => (
          <TableRow key={index}>
            <TableData colSpan={colSpan || 99}>
              <LoadingSkeleton height={73} />
            </TableData>
          </TableRow>
        ))}
    </>
  );
};

const MomentsLoading = () => {
  return (
    <Flex flexDirection="column" style={{ gap: 16 }}>
      {Array(3)
        .fill("")
        .map((_, index) => (
          <MomentSkeletonCard key={index}>
            <Flex alignItems="center" justifyContent="space-between">
              <Flex alignItems="center" style={{ gap: 12 }}>
                <LoadingSkeleton
                  width={40}
                  height={40}
                  style={{ borderRadius: "50%" }}
                />
                <Flex alignItems="center" style={{ gap: 8 }}>
                  <LoadingSkeleton
                    width={24}
                    height={24}
                    style={{ borderRadius: "50%" }}
                  />
                  <LoadingSkeleton width={20} height={16} />
                  <LoadingSkeleton
                    width={24}
                    height={24}
                    style={{ borderRadius: "50%" }}
                  />
                </Flex>
                <LoadingSkeleton width={80} height={16} />
              </Flex>
              <LoadingSkeleton
                width={60}
                height={32}
                style={{ borderRadius: "8px" }}
              />
            </Flex>
          </MomentSkeletonCard>
        ))}
    </Flex>
  );
};

const MomentSkeletonCard = styled(Box)`
  background-color: ${({ theme }) => theme.colors.grey825};
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.ned};
  padding: 16px;
  width: 100%;
`;

export { MatchesLoading, MomentsLoading };
